import { enableProdMode, APP_INITIALIZER, ErrorHandler, NgZone, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { provideRouter, withPreloading, PreloadAllModules, withNavigationErrorHandler } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { addIcons } from 'ionicons';
import {
  archiveOutline, bagHandleOutline, callOutline, duplicateOutline, flagOutline, funnelOutline, lockClosedOutline, pauseCircleOutline, pieChartOutline, saveOutline, settingsOutline, storefrontOutline,
  addCircleOutline, addOutline, alertCircle, alertCircleOutline, analyticsOutline, appsOutline,
  arrowBackOutline, arrowForwardOutline, attachOutline, bookOutline, briefcaseOutline, businessOutline,
  calendarClearOutline, calendarOutline, cardOutline, caretBackOutline, caretForwardOutline, cartOutline, cashOutline,
  checkmarkCircle, checkmarkCircleOutline, checkmarkDoneOutline, checkmarkOutline,
  chevronBackOutline, chevronDown, chevronDownOutline, chevronForwardOutline, clipboardOutline,
  close, closeCircle, closeCircleOutline, closeOutline, cloudOfflineOutline, copyOutline, paperPlaneOutline,
  createOutline, documentAttachOutline, documentOutline, documentTextOutline,
  downloadOutline, expandOutline, eyeOffOutline, eyeOutline, filterOutline, fingerPrintOutline, flashOutline,
  folderOpenOutline, folderOutline, chevronForward, giftOutline,
  helpCircleOutline, homeOutline, hourglassOutline,
  informationCircle, informationCircleOutline, keyOutline, languageOutline, layersOutline, libraryOutline, listOutline, locationOutline,
  lockOpenOutline, logInOutline, logOutOutline, logoAppleAppstore, logoGooglePlaystore, mailOutline, optionsOutline,
  peopleCircleOutline, peopleOutline, personCircle, personCircleOutline, personOutline,
  phonePortraitOutline, pricetagOutline, qrCodeOutline, receiptOutline,
  readerOutline, refreshOutline, reloadOutline, removeOutline, restaurantOutline, ribbonOutline,
  sadOutline, schoolOutline, search, searchOutline, sendOutline, sparklesOutline,
  shieldCheckmarkOutline, swapHorizontalOutline, swapVerticalOutline, syncOutline, textOutline, ticketOutline, timeOutline,
  trashOutline, trendingUpOutline, walletOutline, warning, warningOutline
} from 'ionicons/icons';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { LocalStorageService } from './app/services/local-storage.service';
import { JsBridgeService } from './app/services/js-bridge.service';
import { AppInitService } from './app/services/app-init.service';
import { RefreshTokenInterceptor } from './app/interceptors/refresh-token.interceptor';
import { Forbidden403Interceptor } from './app/interceptors/forbidden-403.interceptor';
import { AcceptLanguageInterceptor } from './app/interceptors/accept-language.interceptor';
import { ApiModule, Configuration } from './app/core/api/generated';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './app/services/transloco-loader';
import { provideEnvironmentNgxCurrency, NgxCurrencyInputMode } from 'ngx-currency';
import { ClientErrorHandler } from './app/services/error-reporting/client-error-handler';
import { ErrorReportingService } from './app/services/error-reporting/error-reporting.service';
import { installGlobalErrorListeners } from './app/services/error-reporting/global-error-listeners';
import { ricaricaSeModuloMancante } from './app/services/modulo-mancante';

addIcons({
  archiveOutline, bagHandleOutline, callOutline, duplicateOutline, flagOutline, funnelOutline, lockClosedOutline, pauseCircleOutline, pieChartOutline, saveOutline, settingsOutline, storefrontOutline,
  addCircleOutline, addOutline, alertCircle, alertCircleOutline, analyticsOutline, appsOutline,
  arrowBackOutline, arrowForwardOutline, attachOutline, bookOutline, briefcaseOutline, businessOutline,
  calendarClearOutline, calendarOutline, cardOutline, caretBackOutline, caretForwardOutline, cartOutline, cashOutline,
  checkmarkCircle, checkmarkCircleOutline, checkmarkDoneOutline, checkmarkOutline,
  chevronBackOutline, chevronDown, chevronDownOutline, chevronForwardOutline, clipboardOutline,
  close, closeCircle, closeCircleOutline, closeOutline, cloudOfflineOutline, copyOutline, paperPlaneOutline,
  createOutline, documentAttachOutline, documentOutline, documentTextOutline,
  downloadOutline, expandOutline, eyeOffOutline, eyeOutline, filterOutline, fingerPrintOutline, flashOutline,
  folderOpenOutline, folderOutline, chevronForward, giftOutline,
  helpCircleOutline, homeOutline, hourglassOutline,
  informationCircle, informationCircleOutline, keyOutline, languageOutline, layersOutline, libraryOutline, listOutline, locationOutline,
  lockOpenOutline, logInOutline, logOutOutline, logoAppleAppstore, logoGooglePlaystore, mailOutline, optionsOutline,
  peopleCircleOutline, peopleOutline, personCircle, personCircleOutline, personOutline,
  phonePortraitOutline, pricetagOutline, qrCodeOutline, receiptOutline,
  readerOutline, refreshOutline, reloadOutline, removeOutline, restaurantOutline, ribbonOutline,
  sadOutline, schoolOutline, search, searchOutline, sendOutline, sparklesOutline,
  shieldCheckmarkOutline, swapHorizontalOutline, swapVerticalOutline, syncOutline, textOutline, ticketOutline, timeOutline,
  trashOutline, trendingUpOutline, walletOutline, warning, warningOutline
});

if (environment.production) {
  enableProdMode();
}

(window as any).__MENSA_PRODUCTION__ = environment.production;

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideIonicAngular({
      mode: 'ios',
      animated: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    }),
    // Dopo un rilascio i chunk della versione precedente non esistono più: una ricarica sola.
    provideRouter(routes, withPreloading(PreloadAllModules), withNavigationErrorHandler(ricaricaSeModuloMancante)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    // Default ngx-currency: `inputMode: Natural` fa leggere le cifre digitate da
    // sinistra a destra (es. "8000" -> 8.000,00 €). Il default della libreria è
    // `Financial`, che riempie i decimali da destra (es. "8000" -> 80,00 €): con
    // quel default il valore letto da `formControl.value` — lo stesso che finisce
    // nel payload di submit (v. `importoANumero` in numero.component.ts) — era due
    // ordini di grandezza sotto quanto digitato dal cittadino (D-32). Allineato al
    // pattern della dashboard (`app.config.ts`), che ha lo stesso difetto risolto
    // allo stesso modo. Le `[options]` locali di `currencyMask` (es.
    // `numero.component.html`) non impostano `inputMode`: lo spread interno di
    // ngx-currency (`{...optionsTemplate, ...options locali}`) lascia quindi
    // vincere questo default globale, senza bisogno di toccare i punti d'uso.
    provideEnvironmentNgxCurrency({
      align: 'right',
      allowNegative: false,
      allowZero: true,
      decimal: ',',
      inputMode: NgxCurrencyInputMode.Natural,
      precision: 2,
      prefix: '',
      suffix: ' €',
      thousands: '.',
      nullable: true,
    }),
    provideTransloco({
      config: {
        availableLangs: ['it', 'en'],
        defaultLang: 'it',
        fallbackLang: 'it',
        reRenderOnLangChange: true,
        missingHandler: {
          // Una chiave mancante ricade sul fallback (it); evita di stampare la chiave grezza.
          useFallbackTranslation: true,
          allowEmpty: false,
        },
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    importProvidersFrom(ApiModule),
    JsBridgeService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: Configuration,
      useFactory: (localStorageService: LocalStorageService) => {
        return new Configuration({
          basePath: environment.servicesUrl,
          accessToken: () => {
            return localStorageService.getAccessToken()!;
          },
        });
      },
      deps: [LocalStorageService], multi: false
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AcceptLanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Forbidden403Interceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () => appInitService.init(),
      deps: [AppInitService],
      multi: true
    },
    // Errori client (vedi reviews/errori-client/SPEC.md): niente provideBrowserGlobalErrorListeners
    // qui (non attivo su questo progetto) — ErrorHandler custom + listener window installati sotto,
    // dopo il bootstrap.
    { provide: ErrorHandler, useClass: ClientErrorHandler },
  ]
}).then((appRef) => {
  const injector = appRef.injector;
  installGlobalErrorListeners(injector.get(NgZone), injector.get(ErrorReportingService));
}).catch(err => console.log(err));
